import { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const FeederLoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const { loginFeeder, googleLogin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get redirect path from location state or default to feeder dashboard
  const redirectPath = location.state?.from?.pathname || '/feeder';
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    if (!email || !password) {
      setError('Please enter both email and password');
      return;
    }
    
    try {
      setLoading(true);
      
      // Use the dedicated feeder login function
      const result = await loginFeeder(email, password);
      
      if (result.success) {
        navigate(redirectPath);
      } else {
        setError(result.message);
      }
    } catch (error) {
      setError('An error occurred during login. Please try again.');
      console.error('Login error:', error);
    } finally {
      setLoading(false);
    }
  };
  
  const handleGoogleLogin = async () => {
    try {
      setLoading(true);
      setError('');
      
      // This is a placeholder for Google login
      // In a real implementation, you'd use the Google Sign-In API
      alert('Google login would be implemented here with Google Sign-In API');
      
      // Simulate a successful login for demo purposes
      const mockGoogleToken = 'mock-google-token';
      const result = await googleLogin(mockGoogleToken);
      
      if (result.success) {
        navigate(redirectPath);
      } else {
        setError(result.message);
      }
    } catch (error) {
      setError('An error occurred during Google login. Please try again.');
      console.error('Google login error:', error);
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="login-page">
      <div className="container">
        <div className="auth-container">
          <div className="auth-header">
            <h1 className="auth-title">Feeder Login</h1>
            <p className="auth-subtitle">
              Login to manage your cats and record feedings
            </p>
          </div>
          
          {error && (
            <div className="error-message">
              {error}
            </div>
          )}
          
          <form className="auth-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={loading}
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={loading}
              />
            </div>
            
            <Link to="/forgot-password" className="forgot-password-link">
              Forgot password?
            </Link>
            
            <button
              type="submit"
              className="button"
              disabled={loading}
            >
              {loading ? 'Logging in...' : 'Login as Feeder'}
            </button>
          </form>
          
          <div className="social-login">
            <p className="social-login-title">Or login with</p>
            
            <div className="social-buttons">
              <button
                className="social-button google-button"
                onClick={handleGoogleLogin}
                disabled={loading}
              >
                <img src="/google-icon.png" alt="Google" width="20" height="20" />
                Google
              </button>
            </div>
          </div>
          
          <div className="form-footer">
            <p>
              Not a feeder yet?{' '}
              <Link to="/feeder-register">Register as a feeder</Link>
            </p>
            <p>
              <Link to="/login" className="user-login-link">
                Login as a user
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeederLoginPage; 